//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { productInfoModal } from '@/views/modals'
import moment from 'moment'
import { getFileUrl } from '@/utils/common'
export default {
  name: 'HomePage',
  extends: vComponent,
  components: { productInfoModal },
  data () {
    return {
      options: [
        { label: '活動標題', key: 'EVENT_NAME' },
        { label: '活動描述', key: 'EVENT_DESC' }
      ],
      selectedLabel: '請選擇',
      items: [], // 取得的資料
      meta: {},
      columns: [ // 欄位宣告
        { name: 'EVENT_NAME', label: '活動標題', field: 'EVENT_NAME' },
        { name: 'EVENT_DESC', label: '活動描述', field: 'EVENT_DESC' },
        { name: 'EVENT_IMG', label: '活動圖片', field: 'EVENT_IMG' },
        { name: 'S_DATE', label: '活動開始日期', field: 'S_DATE' },
        { name: 'E_DATE', label: '活動結束日期', field: 'E_DATE' },
        { name: 'CREATEDATE', label: '發布日期', field: 'CREATEDATE' },
        { name: 'MODIFYDATE', label: '修改日期', field: 'MODIFYDATE' }
      ],
      pagination: {
        page: 1, // 目前第幾頁
        rowsPerPage: 50, // 每頁幾筆
        rowsNumber: 20 // 總筆數
      },
      queryParams: { // 查詢條件
        key: null,
        val: null
      }
    }
  },
  computed: {
    ...mapGetters([
      'builderHost',
      'dateFormat',
      'site',
      'theme'
    ])
  },
  async created () {
    await this.doQuery()
  },
  methods: {
    getFileUrl,
    onOptionClick (key) {
      this.queryParams.key = key
      let label = null
      this.options.forEach(item => {
        if (key === item.key) label = item.label
      })
      if (label !== null) this.selectedLabel = label
    },
    async clickOpenDetail (plucode) {
      /*
      const response = await this.fetch('product', plucode)
      const modalData = response.data
      this.showModal('infoModal', modalData)
      */
    },
    async doQuery () {
      const data = { SITE: this.site }
      if (this.queryParams.key !== null) data[this.queryParams.key] = `%${this.queryParams.val}%`
      data.countPerPage = this.pagination.rowsPerPage
      data.currentPage = this.pagination.page
      // data.E_DATE = `>${new Date()}`
      data.E_DATE = `>${moment().format('YYYY-MM-DD')}` // 避免傳到server api報錯
      const response = await this.fetch('builderApi', this.builderHost, 'crm_event', data)
      this.items = response.data !== null ? response.data : []
      this.meta = response.meta
      this.pagination.rowsNumber = this.meta.total
    },
    formatDate (str) {
      return moment(str).format(this.dateFormat)
    }
  }
}
